import lodash from 'lodash'

export const convertObjectSnakeCaseToCamelCaseProperties = (currentObject: any): any => {
  const newobject = Array.isArray(currentObject) ? [] : {}
  for (let key in currentObject) {
    if (currentObject.hasOwnProperty(key)) {
      const camelCaseKey = key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase())
      let value = currentObject[key]
      if (Array.isArray(value)) {
        if (typeof value[0] === 'object') {
          value = value.map((item) => convertObjectSnakeCaseToCamelCaseProperties(item))
        }
      } else if (typeof value === 'object' && value !== null) {
        value = convertObjectSnakeCaseToCamelCaseProperties(value)
      }
      newobject[camelCaseKey] = value
    }
  }
  return newobject
}
export const convertArraySnakeCaseToCamelCaseProperties = (array: any[] | any): any[] => {
  return array.map((object) => convertObjectSnakeCaseToCamelCaseProperties(object))
}

export const groupObjectsInArrayByProperty = (array: any[], key: string): any => {
  return array.reduce((result, currentItem) => {
    ;(result[currentItem[key]] = result[currentItem[key]] || []).push(currentItem)
    return result
  }, {})
}

export const convertObjectCamelCaseToSnakeCaseProperties = <T extends Record<string, any>>(
  obj: T
): ConvertCamelToSnakeCase<T> => {
  if (!obj || typeof obj !== 'object' || Array.isArray(obj)) {
    return obj as any
  }

  const newObject: any = {}

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const snakeCaseKey = key === key.toUpperCase() || key.includes('_') ? key : lodash.snakeCase(key)

      const value = obj[key]

      if (Array.isArray(value)) {
        newObject[snakeCaseKey] = value.map((item: unknown) =>
          typeof item === 'object' && item !== null ? convertObjectCamelCaseToSnakeCaseProperties(item) : item
        )
      } else if (typeof value === 'object' && value !== null) {
        newObject[snakeCaseKey] = convertObjectCamelCaseToSnakeCaseProperties(value)
      } else {
        newObject[snakeCaseKey] = value
      }
    }
  }

  return newObject as ConvertCamelToSnakeCase<T>
}

type CamelToSnake<S extends string> = S extends `${infer Head}${infer Tail}`
  ? Tail extends Capitalize<Tail>
    ? Tail extends ''
      ? `${Lowercase<Head>}`
      : `${Lowercase<Head>}_${CamelToSnake<Tail>}`
    : `${Lowercase<Head>}${CamelToSnake<Tail>}`
  : S

type ConvertCamelToSnakeCase<T> = {
  [K in keyof T as CamelToSnake<string & K>]: T[K] extends Array<infer U>
    ? U extends Record<string, any>
      ? Array<ConvertCamelToSnakeCase<U>>
      : T[K]
    : T[K] extends Record<string, any>
    ? ConvertCamelToSnakeCase<T[K]>
    : T[K]
}

export const removeNullProperties = <T>(obj: T): T => {
  if (Array.isArray(obj)) {
    return obj.map((item) => removeNullProperties(item)).filter((item) => item !== null) as T
  }

  if (typeof obj === 'object' && obj !== null) {
    const newObj: any = {}
    for (const [key, value] of Object.entries(obj)) {
      if (value !== null) {
        newObj[key] = removeNullProperties(value)
      }
    }
    return newObj
  }

  return obj
}
